import { useQuery } from 'react-query';

export const SAVED_DASHBOARDS_TAB_KEY = 'saved-dashboards-tab';

function useGetSavedDashboardsList(dashboardTabKey, dataSource, queryFn) {
  const { data, isLoading, isError } = useQuery(
    ['saved-dashboards-tab', dashboardTabKey],
    queryFn,
    {
      // sd-todo: tune the settings here
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      select: (response) => {
        const dashboards = response.data || [];
        if (dataSource === 'all') return dashboards;
        return dashboards.filter((it) => it.productName === dataSource) as any[];
      },
    },
  );

  return { data, isLoading, isError };
}

export default useGetSavedDashboardsList;
